<ng-container *transloco="let t">
  <div class="p-1">

    <div class="flex flex-row items-center gap-1 mb-2">
      <span cdkDragHandle class="flex items-center cursor-move">
        <i class="iconify text-lg opacity-60" data-icon="mdi:drag"></i>
      </span>
      <span class="flex-1 text-sm font-medium truncate">{{ field?.label }}</span>

      <button mat-icon-button [matMenuTriggerFor]="menu">
        <i class="iconify scale-80! opacity-80" data-icon="mdi:dots-vertical"></i>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="clear()">
          <div class="flex items-center gap-2">
                 <i class="iconify text-2xl opacity-80" data-icon="solar:eraser-linear"></i>
            <span>{{ t('Clear') }}</span>
          </div>
        </button>
        <button mat-menu-item (click)="removed.emit()">
          <div class="flex items-center gap-2">
            <i class="iconify text-2xl opacity-80" data-icon="solar:trash-bin-2-outline"></i>
            <span>{{ t('Remove filter') }}</span>
          </div>
        </button>
      </mat-menu>
    </div>

    <div class="flex flex-row flex-wrap gap-2">
      <mat-form-field appearance="outline" class="w-full no-subscript">
        <mat-select [ngModel]="operator" (ngModelChange)="onOperatorChange($event)" [disabled]="disabled()">
          @for (option of operators; track option.value) {
          <mat-option [value]="option.value">{{ t(option.label) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (!isToday) {
      @if (isRange) {
      <div class="flex flex-row flex-wrap gap-2">
        <div class="flex flex-row flex-wrap gap-2">
          <mat-form-field appearance="outline" class="flex-1 min-w-36 no-subscript">
            <input matInput [matDatepicker]="startPicker" [placeholder]="t('From')" [ngModel]="start"
              (ngModelChange)="onStartDateChange($event)" [disabled]="disabled()">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker">
              <i matDatepickerToggleIcon class="iconify scale-80!" data-icon="solar:calendar-linear"></i>
            </mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-22 no-subscript">
            <input matInput type="time" [ngModel]="startTime" (ngModelChange)="onStartTimeChange($event)"
              [disabled]="disabled()">
          </mat-form-field>
        </div>
        <div class="flex flex-row flex-wrap gap-2">
          <mat-form-field appearance="outline" class="flex-1 min-w-36 no-subscript">
            <input matInput [matDatepicker]="endPicker" [placeholder]="t('To')" [ngModel]="end"
              (ngModelChange)="onEndDateChange($event)" [disabled]="disabled()">
            <mat-datepicker-toggle matIconSuffix [for]="endPicker">
              <i matDatepickerToggleIcon class="iconify scale-80!" data-icon="solar:calendar-linear"></i>
            </mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-22 no-subscript">
            <input matInput type="time" [ngModel]="endTime" (ngModelChange)="onEndTimeChange($event)"
              [disabled]="disabled()">
          </mat-form-field>
        </div>
      </div>
      } @else {
      <div class="flex flex-row flex-wrap gap-2">
        <mat-form-field appearance="outline" class="flex-1 min-w-36 no-subscript">
          <input matInput [matDatepicker]="picker" [ngModel]="value" (ngModelChange)="onValueDateChange($event)"
            [disabled]="disabled()">
          <mat-datepicker-toggle matIconSuffix [for]="picker">
            <i matDatepickerToggleIcon class="iconify scale-80!" data-icon="solar:calendar-linear"></i>
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-22 no-subscript">
          <input matInput type="time" [ngModel]="valueTime" (ngModelChange)="onValueTimeChange($event)"
            [disabled]="disabled()">
        </mat-form-field>
      </div>
      }
      }
    </div>

  </div>
</ng-container>
